import { render, staticRenderFns } from "./o-header.vue?vue&type=template&id=58b6658e"
import script from "./o-header.js?vue&type=script&lang=js&external"
export * from "./o-header.js?vue&type=script&lang=js&external"
import style0 from "./o-header.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports